import React, { useState, useRef, useEffect } from 'react';

const CustomFieldItem = ({ label, labelNode, name, initialValue, onSave, originalValue, onCopy }) => {
  const [editing, setEditing] = useState(false);
  const [committedValue, setCommittedValue] = useState(initialValue ?? '');
  const [value, setValue] = useState(initialValue ?? '');
  const [saving, setSaving] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (!editing) {
      setCommittedValue(initialValue ?? '');
      setValue(initialValue ?? '');
    }
  }, [initialValue, editing]);

  useEffect(() => {
    if (editing && inputRef.current) inputRef.current.focus();
  }, [editing]);

  const cancel = () => {
    setValue(committedValue);
    setEditing(false);
  };

  const save = async () => {
    setSaving(true);
    try {
      await onSave(value);
      setCommittedValue(value);
      setEditing(false);
    } catch {
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      {labelNode ?? (label ? <h4 className='category-subtitle member-info-subtitle'>{label}</h4> : null)}
      {editing ? (
        <p className='mb-0 member-data d-flex align-items-center'>
          <input
            ref={inputRef}
            type='text'
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') save();
              if (e.key === 'Escape') cancel();
            }}
            style={{ width: '180px', outline: 'none' }}
            className='rounded border-general border-grey py-1 px-2'
          />
          <button className='action-button btn general-button py-1 px-2 ml-2' onClick={save} disabled={saving}>
            {saving ? <i className='fas fa-spinner fa-spin d-inline-block' style={{ marginBottom: '-3px' }} /> : 'Save'}
          </button>
          <button className='general-button simple-link-button ml-2' onClick={cancel}>
            Cancel
          </button>
        </p>
      ) : (
        <p className='mb-0 member-data mt-2'>
          {committedValue ? (
            <>
              {committedValue}
              {originalValue && originalValue !== committedValue && (
                <span
                  className='icon-info paragraph-p4 light-60-text ml-1 d-inline-block'
                  data-tooltip-content={`Original: ${originalValue}`}
                  data-tooltip-id='general-tooltip'
                />
              )}
              {onCopy && (
                <button
                  className='general-button member-email-button'
                  onClick={onCopy}
                  data-tooltip-content='Copy'
                  data-tooltip-id='general-tooltip'
                >
                  <span className='icon-copy-thin paragraph-p4 light-60-text font-weight-normal d-inline-block' />
                </button>
              )}
              <button
                className='general-button member-email-button'
                onClick={() => {
                  setValue(committedValue);
                  setEditing(true);
                }}
                data-tooltip-content='Edit'
                data-tooltip-id='general-tooltip'
              >
                <span className='icon-edit-pencil paragraph-p4 light-60-text font-weight-normal d-inline-block' />
              </button>
            </>
          ) : (
            <button
              className='general-button simple-link-button'
              onClick={() => {
                setValue('');
                setEditing(true);
              }}
            >
              + Add {name ?? label?.toLowerCase()}
            </button>
          )}
        </p>
      )}
    </>
  );
};

export default CustomFieldItem;
